import { render, staticRenderFns } from "./launch.vue?vue&type=template&id=38734055&"
import script from "./launch.vue?vue&type=script&lang=ts&"
export * from "./launch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports